import { doc, getDoc } from "firebase/firestore";
import db from "./firebase/firebaseConfig";

const DOC_ID = "digitalcoreweb.online";

// Older docs only have `liveSite` ("aw" meant show the AW site).
function readRedirect(data) {
  if (typeof data?.redirect === "boolean") return data.redirect;
  return data?.liveSite !== "digi";
}

export async function isRedirectOn() {
  try {
    const snap = await getDoc(doc(db, "siteConfig", DOC_ID));
    return snap.exists() ? readRedirect(snap.data()) : false;
  } catch (err) {
    console.warn("Redirect check failed", err);
    return false;
  }
}
